import React from 'react'
import '../App.css'
import './TextOnImageSection.css'
import { Title } from './Title'

const STYLES = [
  'textonimage--corn',
  'textonimage--wheat',
  'textonimage--soybeans',
  'textonimage--rice',
]

function TextOnImageSection({ title, desc, type, textonimageStyle }) {
  const checkTextOnImageStyle = STYLES.includes(textonimageStyle)
    ? textonimageStyle
    : STYLES[0]

  return (
    <div className={`textonimage ${checkTextOnImageStyle}`} type={type}>
      <div className='sol-text-container'>
        <div className='textonimage-title'>
          <Title
            className='title'
            titleStyle='title--title3'
            titleSize='title--small'
          >
            {title}
          </Title>
        </div>
        <div className='sol-text-bg'>
          <div className='text-bg-trans'>
            {desc.map((d) => (
              <div>
                <p key={d} value={d} className='text-trans'>
                  {d}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default TextOnImageSection
